<template>
	<div>
		<div class="partner-card-wrapper px-4 py-4 mb-4">
			<img :src="partner.partner_logo"
           alt="partnerLogo"
           class="partner-card-logo"
           loading="lazy"
      />

			<div>
				<div class="partner-card-tittle">
					{{ partner.partner_name }}
				</div>
				<div class="partner-card-description">
					{{ partner.partner_brief_description }}
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import Vue from 'vue'
import VueScrollTo from 'vue-scrollto'

Vue.use(VueScrollTo)

export default {
	name: 'PartnerCard',

	props: {
		partner: {
			type: Object,
			default: () => {},
		},
	},
}
</script>

<style lang="scss">
.partner-card {
	&-wrapper {
		display: flex;
		background: rgb(251, 251, 251);
		border: 1px solid rgb(226, 226, 226);
		border-radius: 12px;
	}

	&-logo {
		width: 25%;
		object-fit: contain;
		margin-right: 10px;
	}
	&-tittle {
		color: rgb(74, 74, 74);
		font-size: 14px;
		font-family: Montserrat;
		font-weight: bold;
	}

	&-description {
		color: rgb(74, 74, 74);
		font-size: 14px;
		font-family: Montserrat;
		font-weight: normal;
		line-height: 20px;
	}
}
</style>
